"use client";

import { memo, type ReactElement } from "react";
import { ColorType } from "@/theme/colors";
import { FontWeight } from "@/theme/typography";
import { Ctext } from "../Ctext";
import {
  CTEAMCARD_TEXT_CLAMP_STYLE,
  getCteamcardCatchPhraseFontSize,
} from "./Cteamcard.styles";

interface CteamcardCatchPhraseProps {
  catchPhrase?: string;
  isMobile: boolean;
}

export const CteamcardCatchPhrase = memo(function CteamcardCatchPhrase({
  catchPhrase,
  isMobile,
}: CteamcardCatchPhraseProps): ReactElement | null {
  if (!catchPhrase) {
    return null;
  }

  const fontSize = getCteamcardCatchPhraseFontSize({ isMobile });

    return (
    <Ctext
      color={ColorType.White}
      weight={FontWeight.Medium}
      opacity={0.7}
      style={{
        flex: 1,
        ...CTEAMCARD_TEXT_CLAMP_STYLE,
        fontSize,
        paddingRight: "15%",
        maskImage: "linear-gradient(180deg, black 50%, transparent 100%)",
        WebkitMaskImage: "linear-gradient(180deg, black 50%, transparent 100%)",
      }}
    >
      {catchPhrase}
    </Ctext>
  );
});
